import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/vuex/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 900000 // request timeout (15 minutes)
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (localStorage.getItem('loginUserInfo')) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      let userInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
      if (userInfo) {
        let token = JSON.parse(localStorage.getItem('loginUserInfo')).token
        let tokenHead = JSON.parse(localStorage.getItem('loginUserInfo')).tokenHead
        config.headers['Authorization'] = tokenHead + token
      } else {
        config.headers['Authorization'] = ""
      }

    }
	//获得域名
	let host = document.domain;
	let corpId=82;
	//根据域名得到不同公司ID
	if(host.indexOf('mall81.') >=0){
		corpId=81;
	}else if(host.indexOf('mall82.') >=0 || host.indexOf('mall.') >=0){
		corpId=82;
	}else if(host.indexOf('mall83.') >=0){
		corpId=83;
    }else if(host.indexOf('mall84.') >=0){
		corpId=84;
    }else if(host.indexOf('prod1490.gemsafe.') >=0){
      corpId=1490;
      }

	config.headers['tenantId'] = corpId;
    /*if (localStorage.getItem("tenantId")){
      config.headers['tenantId'] = localStorage.getItem("tenantId");
    }else {
      config.headers['tenantId'] = '82';
    }*/
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (!response.hasOwnProperty("data")) {
      return response
    }

    const res = response.data

    // if the custom code is not 200, it is judged as an error.
    //TODO: 后续需要修改
    if (res.hasOwnProperty("code") && res.code !== 200) {
      // // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      // if (res.code === 404) {
      //   this.$router.push({path: '/404'})
      // }
      switch (res.code) {
        case 400:
          Message({
            message: res.msg || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          break
        case 401:
          let token = response.config.headers["Authorization"];
          if (token !== "" && token !== undefined && token !== null) {
            //token过期或者不正确，清除登录信息后重新加载当前页
            localStorage.removeItem("loginUserInfo")
            location.reload()
            // router.replace({path: '/login'})
          } else {
            store.commit('SHOW_LOGIN_BOX')
          }
          break
        case 403:
          router.replace({path: '/403'})
          break
        case 404:
          router.replace({path: '/404'})
          break
        case 500:
          Message({
            message: '系统繁忙',
            type: 'error',
            duration: 5 * 1000
          })
          break
      }
      if(res.code>1000){
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      //取分页对象
      let xPage = response.headers["x-pagination"];
      if (xPage) {
        let pagination = JSON.parse(response.headers["x-pagination"])
        if (pagination) {
          response.pagination = pagination
        }
      }
      return response
    }
  },
  error => {
    console.log(error)
    console.log('err' + error) // for debug
    if(error=='Error: Network Error'){
      Message({
        message: '与服务器连接丢失',
        type: 'error',
        duration: 5 * 1000
      })
    }else{
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js